type TipsValueButtonProps = {
  label: string;
  onClick: () => void;
};
export const TipsValueButton = ({ label, onClick }: TipsValueButtonProps) => {
  return (
    <div
      className="px-4 py-1.5 text-black bg-white border border-gray-200 rounded-md touchable hover:bg-gray-50 text-center"
      onClick={onClick}
    >
      {label}
    </div>
  );
};
